import React from 'react'
import FormGroup from '@mui/material/FormGroup';
import { styled } from '@mui/material/styles';
import Square from '@mui/icons-material/Square';
import CheckBoxMat from '@mui/icons-material/CheckBox';
import { Typography, Button } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';


const FormGroupColor = styled(FormGroup)(({ theme }) => ({

  // Some CSS
  overflowY: "auto",
  flexDirection: "row",
  margin: 0,
  padding: 0,
  listStyle: "none",
  height: "100%",
  scrollbarWidth: "thin",
  '&::-webkit-scrollbar': {
    width: '0.2em'
  },
  '&::-webkit-scrollbar-track': {
    boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
    webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)'
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'rgba(0,0,0,.1)',
    outline: '1px solid rgb(0 0 0 / 54%)'
  }
  ,
}));


function IconCheckboxes(props) {
  const [checked, setChecked] = React.useState(props.checked);

  const handleClick = (event) => {
    console.log(event.target.id, props.code);
    let code = props.code;
    let value = event.target.id;
    if (checked.hasOwnProperty(code)) {

      let currentIndex = checked[code].indexOf(value);
      if (currentIndex === -1) {
        checked[code].push(value);
      } else {
        checked[code].splice(currentIndex, 1);
      }


    }
    else {
      if (code != "")
        checked[code] = [value];
    }


    setChecked(checked);
    props.setCheckenFiltr(checked);
    props.submitForm();
  };

  return (
    <>
      <Checkbox sx={{ p: 0, color: props.color }} id={props.nameValeu} data-name={props.code}
        onChange={handleClick}
        icon={<Square sx={{ fontSize: "2rem",}}/>} checked={checked[props.code] ? checked[props.code].indexOf(props.nameValeu) !== -1 : false} checkedIcon={<CheckBoxMat sx={{ color: props.color,fontSize: "2rem" }}

        />} />
    </>
  );
}

function DisplayTypeCompanentG(props) {

  const [openBlock, setOpenBlock] = React.useState(true);

  return (
    <>


      {openBlock &&

        (

          <>

            <FormGroupColor
              sx={{ width: '100%', maxWidth: '100%', maxHeight: '100%', bgcolor: 'background.paper', overflow: 'auto', height: 'auto' }}

            >
              {//hexSorter.sortColors(colorArray, 'mostBrightColor').reverse().sort()
                props.propertyvaluecolor.sort()
                .map((value, i) => {


                  return (
                    <IconCheckboxes key={i} color={value} id={value.ID} code={props.code} countfiltr={value.countfiltr} nameValeu={value.slice(1)} checked={props.checked} submitForm={props.submitForm} setCheckenFiltr={props.setCheckenFiltr} />
                  );
                })}
            </FormGroupColor>
          </>
        )

      }
    </>
  )
}

export default DisplayTypeCompanentG;
